import { matchPath } from "react-router-dom";

import { AssignStatus } from "@/enum/list.enum";
import { ROUTE_CONFIG } from "@/routes/config";

import { buildListDetailLink } from "../../List/utils/buildListDetailLink";

export const resolveLegacyTrackerTarget = (
	pathname: string,
	tracker?: { listId?: number | null }
): string => {
	const base = ROUTE_CONFIG.PROFILE_TRACKER;

	if (matchPath(`${base}/create`, pathname)) {
		return ROUTE_CONFIG.NEW_LIST;
	}

	const isTrackerRoute = ["detail", "edit", "settings"].some((page) =>
		matchPath(`${base}/${page}/:id`, pathname)
	);

	if (isTrackerRoute && typeof tracker?.listId === "number") {
		return buildListDetailLink({
			listId: tracker.listId,
			assignStatus: AssignStatus.TRACKED_PROFILE,
		});
	}

	return ROUTE_CONFIG.LISTS;
};
